import {ImageUrlString} from '../../classes/images/imageUrl';
import {image} from './image';
/**
 * @name convertImageUrlToWebP
 */
export const convertImageUrlToWebP = (url: string): ImageUrlString =>
  image(url).webp();
